// The variants are actually imported by the theme, but colocating helps finding them more easily.
const textVariants = {
    large: {
        variant: 'text.default',
        fontWeight: 'light',
        fontSize: 'large',
        lineHeight: 'large',
        letterSpacing: 'large',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    semiTitle: {
        variant: 'text.default',
        fontSize: 'body',
        lineHeight: 'small',
        fontWeight: 'semibold',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    default: {
        fontFamily: 'body',
        fontWeight: 'body',
        fontSize: 'body',
        lineHeight: 'body',
        letterSpacing: 'body',
    },
    small: {
        variant: 'text.default',
        fontSize: 'small',
        lineHeight: 'small',
        letterSpacing: 'small',
    },
    smallest: {
        variant: 'text.default',
        fontSize: 'smallest',
        lineHeight: 'smallest',
        letterSpacing: 'smallest',
    },
};
export default textVariants;
/**
 * @typedef {keyof textVariants} TextVariants
 */
//# sourceMappingURL=textVariants.js.map